
export const isValueChangingKey = function(which) {
  // Keys that cause the input to be modified.  Includes things like Backspace,
  // characters, numbers, etc.  Doesn't include arrow keys.
  // https://css-tricks.com/snippets/javascript/javascript-keycodes/
  if ([8, 9, 46].indexOf(which) >= 0) {
    return true;
  }
  if (which >= 48 && which <= 57) {
    return true;
  }
  if (which >= 65 && which <= 90) {
    return true;
  }
  if (which >= 96 && which <= 111) {
    return true;
  }
  if (which >= 186 && which <= 222) {
    return true;
  }
  return false;
};
